"use client";

import { ScrollReveal } from "@/components/ui/scroll-reveal";

const features = [
  {
    pain: "«Я не знаю, зарабатываю или теряю»",
    title: "Прибыль по каждому артикулу и размеру",
    description:
      "Не средняя по магазину — а точная прибыль или убыток по каждому товару. С учётом комиссии, логистики, хранения, рекламы и штрафов.",
  },
  {
    pain: "«Комиссии выросли, а я не вижу куда уходит выручка»",
    title: "Полная структура расходов",
    description:
      "Видите каждую статью расходов: комиссия маркетплейса, логистика, хранение, реклама, штрафы. По WB и Ozon отдельно.",
  },
  {
    pain: "«Закупочная цена менялась, себестоимость неточная»",
    title: "Автоматический расчёт себестоимости",
    description:
      "Загрузите партии закупок — система рассчитает себестоимость каждой продажи автоматически. Даже если цена менялась от партии к партии.",
  },
  {
    pain: "«Товар закончился, а я не заметил»",
    title: "Прогноз поставок по каждому размеру",
    description:
      "Размер L закончится через 3 дня, XL — через 20. Система считает сколько заказать, чтобы не остаться без товара.",
  },
  {
    pain: "«Реклама не окупается, а я узнаю поздно»",
    title: "Алерты когда товар уходит в минус",
    description:
      "10+ типов умных алертов: убыточный товар, реклама не окупается, запас заканчивается. С конкретной рекомендацией что делать.",
  },
  {
    pain: "«Отчёт WB приходит через 2-3 недели»",
    title: "Данные без задержки",
    description:
      "Не ждите финализированный отчёт. Видьте предварительные данные сразу. Когда отчёт придёт — цифры пересчитаются автоматически.",
  },
];

export function FeaturesGrid() {
  return (
    <section id="features" className="py-24 px-6 border-t border-white/[0.06]">
      <div className="max-w-5xl mx-auto">
        <ScrollReveal>
          <p className="text-sm font-medium text-purple-400 text-center mb-4">
            Как MPUNIT решает эти проблемы
          </p>
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-white tracking-tight text-center">
            Каждая фича — ответ
            <br />
            <span className="text-white/50">на конкретную боль</span>
          </h2>
        </ScrollReveal>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mt-16">
          {features.map((feature, index) => (
            <ScrollReveal key={feature.title} delay={index * 0.08}>
              <div className="group">
                <p className="text-xs text-white/30 italic mb-3">
                  {feature.pain}
                </p>
                <h3 className="text-lg font-semibold text-white mb-2">
                  {feature.title}
                </h3>
                <p className="text-sm text-white/50 leading-relaxed">
                  {feature.description}
                </p>
              </div>
            </ScrollReveal>
          ))}
        </div>
      </div>
    </section>
  );
}
